import * as generic from "@/store/generic/mutations/result-status.js";
import actions from "./actions";

// Import any requires library
/* eslint-disable no-unused-vars */
import { getField, updateField } from 'vuex-map-fields';

// Initial states
const state = {
  processing: false,
  error: null,
  success: null,
  currentLearningCourse: null,
  currentUser: localStorage.getItem('user') != null ? JSON.parse(localStorage.getItem('user')) : null,
  profile: {},
  token: localStorage.getItem('token') != null ? localStorage.getItem('token') : null,
  loginError: null,
  loginStatus: null,
  forgotMailSuccess: null,
  resetPasswordSuccess: null,
};

// getters
const getters = {
  getField
};

// mutations
const mutations = {
  updateField,
  clearError: generic.clearError,
  /* clearError: (state) => {
    state.error = null;
  }, */

  setError: generic.setError,
  /* setError: (state, payload) => {
    state.error = payload;
    state.success = null;
    state.processing = false;
  }, */

  setProcessing: generic.setProcessing,
  /* setProcessing: (state, payload) => {
    state.processing = payload;
  }, */

  setSuccess: generic.setSuccess,
  // setSuccess: (state, payload) => {
  //   state.error = null;
  //   state.success = payload;
  //   state.processing = false;
  // },

  setCourseToLearn: (state, payload) => {
    state.currentLearningCourse = payload;
  },

  setCurrentUser(state, payload) {
    state.currentUser = payload;
    state.processing = false;
    state.loginError = null;
    state.error = null;
  },

  setToken(state, payload) {
    state.token = payload;
    state.processing = false;
    state.loginError = null;
    state.error = null;
  },

  setLogout(state) {
    state.currentUser = null;
    state.token = null;
    state.processing = false;
    state.loginError = null;
    state.error = null;
  },

  setLoginError(state, payload) {
    state.loginError = payload;
    state.currentUser = null;
    state.processing = false;
  },

  setLoginStatus(state, payload) {
    state.loginStatus = payload;
    state.currentUser = null;
    state.processing = false;
  },

  setForgotMailSuccess(state) {
    state.loginError = null;
    state.currentUser = null;
    state.token = null;
    state.processing = false;
    state.forgotMailSuccess = true;
  },

  setResetPasswordSuccess(state) {
    state.loginError = null;
    state.currentUser = null;
    state.token = null;
    state.processing = false;
    state.resetPasswordSuccess = true;
  },

  setUser: (state, payload) => {
    state.currentUser = payload;
  },

  setProfile: (state, payload) => {
    state.profile = payload.teacher;
  },

  removeUserState: (state) => {
    state.currentUser = null;
  },

  removeUserProfile: (state) => {
    state.profile = null;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
